
/**
 * This is used for the decision made for each introduction wizard step
 */

import { Choice } from "./choice";

export class Decision {
   nthDecision: Number;
   enable : Boolean;
   required: Boolean;
   question: string;
   tips: Object[]; //List of important tips we wish to share with the user about this decision
   advertisments?: Object[]; //List of advertisments to include on this decision
   image: string;
   choices : Choice[]; //List of choices
   description: string;
   previousTitle: string;
   previousDirection: string;
   nextTitle: string;
   nextDirection: string; 
   filler?: string;
   selectedOption: Choice | undefined;  //This is not apart of the firebase data model. This is just used to keep the persistent local storage.
   
   constructor(nthDecision: number, enable: boolean, required: boolean, question: string, choices: Choice[], description: string, 
         tips: Object[], image: string, nextTitle: string, nextDirection: string, previousTitle: string, previousDirection: string, filler?: string) {

    this.nthDecision = nthDecision;
    this.enable = enable;
    this.required = required;
    this.question = question;
    this.choices = choices;
    this.description = description;
    this.tips = tips;
    this.image = image;
    this.nextTitle = nextTitle;
    this.nextDirection = nextDirection;
    this.previousTitle = previousTitle;
    this.previousDirection = previousDirection
    this.selectedOption = undefined;
    if(!!filler) {
      this.filler = filler;
    }
   }

   setTips(tips: any[]) {
      this.tips = tips;
   }
}